import { render } from "./BACUploadFile.vue?vue&type=template&id=91f8130e&scoped=true"
import script from "./BACUploadFile.vue?vue&type=script&lang=js"
export * from "./BACUploadFile.vue?vue&type=script&lang=js"

import "./BACUploadFile.vue?vue&type=style&index=0&id=91f8130e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f8130e"]])

export default __exports__